import { createFileRoute } from '@tanstack/react-router';
import HomePage from '../components/webdesigned/home/HomePage';
import WebDesignedPortal from '../components/portals/WebDesignedPortal';

export const Route = createFileRoute('/')({
  component: () => (
    <WebDesignedPortal>
      <HomePage />
    </WebDesignedPortal>
  ),
});
